module.exports = {
          srcSet: __webpack_public_path__ + "56d3723953938a3f4f26a33d9d4fdbb0-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "56d3723953938a3f4f26a33d9d4fdbb0-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "56d3723953938a3f4f26a33d9d4fdbb0-24.png",
          toString:function(){return __webpack_public_path__ + "56d3723953938a3f4f26a33d9d4fdbb0-24.png"},
          
          width: 24,
          height: 24
        }